module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-BOOSTER-GREEN-3.4d3251fe.jpg";